import { reactive } from 'vue';
import { IState } from './interfaces/IState';
import { IGetters } from './interfaces/IGetters';
import { EventAggregationService } from '../platform/EventAggregationService';
import { injectable } from 'inversify';
import { IStore } from './interfaces/IStore';
import { State } from './State';
import { Getters } from './Getters';
import { Mutations } from './Mutations';
import { Actions } from './Actions';
import { IActions } from './interfaces/IActions';

@injectable()
export class Store implements IStore {
	public readonly getters: IGetters;
	public readonly actions: IActions;

	public constructor(eventAggregationService: EventAggregationService) {
		const state: IState = reactive<IState>(new State());
		const getters = new Getters(state);

		this.actions = new Actions(getters, new Mutations(state), eventAggregationService);
		this.getters = getters;
	}
}
